export enum PageTemplates {
  /** Template "eA" from wireframes. col-12 always. */
  fullWidth = 'fullWidth',
  /** Template "eC" from wireframes. col-10 when on desktop. */
  truncated = 'truncated',
  /** Template "eD" from wireframes. col-md-4 col-12. */
  centered = 'centered',
  /** Template "eE" from wireframes. col-md-9 offset-md-1 */
  truncateOffset1 = 'truncateOffset1',
}
